import React from 'react'
import { Globe } from 'lucide-react'
import GenericTabelaPage from '../../components/tabelas/GenericTabelaPage'
import { mercadosApi } from '../../api/tabelasBasicas'

const MercadosPage: React.FC = () => (
  <GenericTabelaPage
    titulo="Mercados"
    breadcrumb="Tabelas › Básicas"
    icon={<Globe size={17} />}
    cdMaxLen={4}
    nmMaxLen={100}
    api={mercadosApi}
  />
)

export default MercadosPage
